module.exports = __webpack_public_path__ + "static/media/Construction.884dd441.jpeg";